import TeamBuilder from "@/Components/TeamBuilder/team_builder_core/TeamBuilder";
import { Card } from "@/Components/ui/card";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import { useIsMobile } from "@/hooks/use-mobile";

const Team = () => {
  const zoomLevel = useResponsiveZoom();
  const isMobile = useIsMobile();

  return (
    <Card className="p-2 m-2" style={{ zoom: zoomLevel }}>
      <div className={`${isMobile ? "text-4xl" : "text-2xl"} font-bold ml-2`}>Team</div>
      <div className={`${isMobile ? "text-lg" : "text-sm"} text-gray-500 ml-2`}>Manage your team members</div>
      <TeamBuilder />
    </Card>
  );
}

export default Team